import { IDatePresetButtonValues, IDatePresetSelectValues } from '@private/datepicker';
import { enUS, uk, vi } from 'date-fns/locale';

import { LANGUAGES } from 'store/userConfiguration';

export const DATE_PRESET_BUTTONS = [
  { label: 'presets.currentDay', value: 'days', variant: 'current' },
  { label: 'presets.previousDay', value: 'days', variant: 'prev' },
  { label: 'presets.currentWeek', value: 'weeks', variant: 'current' },
  { label: 'presets.previousWeek', value: 'weeks', variant: 'prev' },
  { label: 'presets.currentMonth', value: 'months', variant: 'current' },
  { label: 'presets.previousMonth', value: 'months', variant: 'prev' },
] as IDatePresetButtonValues[];

export const LANGUAGE_LOCALES = {
  [LANGUAGES.EN]: enUS,
  [LANGUAGES.UK]: uk,
  [LANGUAGES.VI]: vi,
};

export const TR_DATE_PRESET_OPTIONS = [
  {
    label: 'presets.previousHours',
    maxNumber: 90 * 24,
    type: 'hours',
    value: 2,
    variant: 'prev',
  },
  {
    label: 'presets.previousDays',
    maxNumber: 90,
    type: 'days',
    value: 4,
    variant: 'prev',
  },
  {
    label: 'presets.previousWeeks',
    maxNumber: 12,
    type: 'weeks',
    value: 6,
    variant: 'prev',
  },
  {
    label: 'presets.previousMonths',
    maxNumber: 2,
    type: 'months',
    value: 8,
    variant: 'prev',
  },
] as IDatePresetSelectValues[];

// Longest span each preset unit can resolve to, so a preset is only offered when the
// resolved window can hold its worst case (a month is up to 31 days). A unit with no
// entry here stays hidden — an undeclared preset must never reach the backend.
export const DATE_PRESET_BUTTON_MIN_DAYS: Record<string, number> = {
  days: 1,
  months: 31,
  weeks: 7,
};

export const getBoundedDatePresetButtons = (
  windowDays: number,
): IDatePresetButtonValues[] =>
  DATE_PRESET_BUTTONS.filter(
    ({ value }) => windowDays >= DATE_PRESET_BUTTON_MIN_DAYS[value],
  );

export const getBoundedDatePresetSelects = (
  windowDays: number,
): IDatePresetSelectValues[] =>
  [
    {
      label: 'presets.previousHours',
      maxNumber: windowDays * 24,
      type: 'hours',
      value: 2,
      variant: 'prev',
    },
    {
      label: 'presets.previousDays',
      maxNumber: windowDays,
      type: 'days',
      value: 4,
      variant: 'prev',
    },
    {
      label: 'presets.previousWeeks',
      maxNumber: Math.floor(windowDays / 7),
      type: 'weeks',
      value: 6,
      variant: 'prev',
    },
  ] as IDatePresetSelectValues[];
